/**
 * Returns the cart drawer to the top each time it opens.
 *
 * The drawer is hidden with `display: none` rather than being torn down, so `.drawer__scrollable`
 * keeps whatever `scrollTop` it had when it closed. Reopening therefore drops the shopper back
 * partway down a list they have no context for — measured: scroll to 159px, close, reopen, still
 * at 159px. Adding an item is the common case, and it lands at the bottom of the list, so the
 * stale position is most misleading exactly when it matters most.
 *
 * The open state is read off the `drawer--is-open` class. `theme.Drawers` adds it synchronously
 * just before dispatching `drawerOpen.CartDrawer`, so that event marks the same transition; the
 * observer is not load-bearing over it. Reset on the transition into open only — resetting on
 * every mutation would fight the shopper mid-scroll, since the cart re-renders on quantity and
 * removal changes.
 */
const initCartDrawerScrollReset = () => {
  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return null;

  const OPEN = 'drawer--is-open';
  let wasOpen = drawer.classList.contains(OPEN);

  const observer = new MutationObserver(() => {
    const isOpen = drawer.classList.contains(OPEN);
    if (isOpen && !wasOpen) {
      // Queried per open: the cart re-renders its contents, so this element is replaced.
      const scroller = drawer.querySelector('.drawer__scrollable');
      if (scroller) scroller.scrollTop = 0;
    }
    wasOpen = isOpen;
  });

  observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });

  return () => observer.disconnect();
};

initCartDrawerScrollReset();
